import React from 'react';
import { Helmet } from 'react-helmet-async';
import WhatsAppCTA from '../components/WhatsAppCTA';

const Services = () => {
  const services = [
    {
      title: 'Exterior Detailing',
      description: 'Complete exterior wash, clay treatment, tire shine, and protective wax application.',
      features: [
        'Hand wash with premium products',
        'Clay bar treatment',
        'Tire and rim cleaning',
        'Window cleaning',
        'Slick mist speed wax'
      ]
    },
    {
      title: 'Interior Detailing',
      description: 'Thorough interior cleaning, conditioning, and protection for all surfaces.',
      features: [
        'Deep vacuum of carpets and seats',
        'Leather/fabric conditioning',
        'Dashboard and console cleaning',
        'Door jamb cleaning',
        'Interior window cleaning'
      ]
    },
    {
      title: 'Paint Correction',
      description: 'Multi-stage buffing process to remove swirls, scratches, and restore paint clarity.',
      features: [
        'Paint inspection and assessment',
        'Multi-stage buffing',
        'Swirl mark removal',
        'Scratch removal',
        'Paint protection application'
      ]
    },
    {
      title: 'Ceramic Coating',
      description: 'Long-lasting protection with hydrophobic properties and enhanced gloss.',
      features: [
        'Paint correction preparation',
        'Professional grade ceramic coating',
        'Hydrophobic protection',
        'UV protection',
        'Enhanced gloss and depth'
      ]
    },
    {
      title: 'Chrome & Aluminum Polishing',
      description: 'Restore shine and remove oxidation from metal surfaces.',
      features: [
        'Oxidation removal',
        'Metal polishing',
        'Chrome restoration',
        'Protective coating',
        'Enhanced shine'
      ]
    },
    {
      title: 'Specialty Services',
      description: 'Additional services for specific needs.',
      features: [
        'Pet hair removal',
        'Nicotine odor removal',
        'Engine bay cleaning',
        'Headlight restoration',
        'Odor elimination'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-black py-16 px-4">
      <Helmet>
        <title>Car Detailing Services Tralee | Interior, Exterior, Ceramic | Kingdom Auto Detailing</title>
        <meta name="description" content="Full range of car detailing services near Tralee: interior deep cleaning, exterior wash & polish, ceramic coating, paint correction, engine bay cleaning. Serving Tralee, Listowel, Ardfert. Book today!" />
        <meta name="keywords" content="car detailing services Tralee, interior car cleaning Tralee, exterior detailing Tralee, paint correction Tralee, ceramic coating Tralee, pet hair removal Tralee, engine bay cleaning Tralee, car valeting services Tralee Kerry, professional car cleaning Tralee" />
        <link rel="canonical" href="https://kingdomautodetailing.ie/services" />
      </Helmet>

      <div className="max-w-7xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 text-center">
          Car Detailing Services Tralee
        </h1>
        <p className="text-xl text-gray-400 text-center mb-12 max-w-3xl mx-auto">
          Professional automotive detailing services in Tralee, Listowel, Ardfert and all of North Kerry
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="bg-gradient-to-br from-blue-600 to-blue-700 rounded-3xl p-8 hover:scale-105 transition-transform duration-300"
            >
              <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
              <p className="text-blue-100 mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIdx) => (
                  <li key={featureIdx} className="text-white flex items-start">
                    <span className="text-amber-500 mr-2">✓</span>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* WhatsApp CTA */}
        <div className="mt-16">
          <WhatsAppCTA />
        </div>

        <div className="mt-16 bg-zinc-900 rounded-3xl p-8 md:p-12 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Why Choose Kingdom Auto Detailing?</h2>
          <p className="text-gray-300 text-lg max-w-3xl mx-auto leading-relaxed">
            We use only the highest quality products and techniques to ensure your vehicle receives the best care possible. 
            Our experienced team is dedicated to delivering exceptional results that exceed your expectations.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Services;